import { render } from "./BrowserUpdateWarning.vue?vue&type=template&id=b99faf80&scoped=true"
import script from "./BrowserUpdateWarning.vue?vue&type=script&lang=js"
export * from "./BrowserUpdateWarning.vue?vue&type=script&lang=js"

import "./BrowserUpdateWarning.vue?vue&type=style&index=0&id=b99faf80&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99faf80"]])

export default __exports__